export default "__VITE_ASSET__123430b0__"